import { forwardRef } from 'react';

import { ListProps } from '@mui/material';

import StyledList from '@webclient/components/search-forms/gamification-search/actions/bots-selector/components/listbox/styles';

type Props = ListProps;

const ListboxComponent = forwardRef<HTMLUListElement, Props>((props, ref) => {
  return (
    <StyledList
      {...props}
      ref={ref}
    />
  );
});

export default ListboxComponent;
